import { render, staticRenderFns } from "./RModalSimple.vue?vue&type=template&id=67c9a090&scoped=true&"
import script from "./RModalSimple.vue?vue&type=script&lang=js&"
export * from "./RModalSimple.vue?vue&type=script&lang=js&"
import style0 from "./RModalSimple.vue?vue&type=style&index=0&id=67c9a090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9a090",
  null
  
)

export default component.exports